import React from 'react';
import RegisterForm from './pages/RegisterForm';
import Home from './pages/Home';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import SignIn from './pages/SignIn';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import ChangePassword from './pages/ChangePassword';
import ThankYou from './pages/ThankYou';
import BookingReport from './pages/BookingReport';
import ForgotPassword from './pages/ForgotPassword';
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./msalConfig";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useState, useEffect } from "react";

function Profile() {
  const { accounts } = useMsal();
  return (
    <div>
      <h2>Profile Information</h2>
      {accounts.length > 0 ? (
        <div>
          <p>Welcome, {accounts[0].username}!</p>
        </div>
      ) : (
        <p>No account information available.</p>
      )}
    </div>
  );
}

const useMsalInstance = () => {
  const [msalInstance, setMsalInstance] = useState(null);

  useEffect(() => {
    const initializeMsal = async () => {
      const instance = new PublicClientApplication(msalConfig);
      await instance.initialize();
      setMsalInstance(instance);
    };

    initializeMsal();
  }, []);

  return msalInstance;
};


function App() {
  const msalInstance = useMsalInstance();

  return (
    <div>
      {
        msalInstance ? (
          <MsalProvider instance={msalInstance}>
            <BrowserRouter future={{
              v7_startTransition: true, v7_relativeSplatPath: true
            }}>
              <Routes>
                <Route path='/0ea299dc-f1a6-40d3-9837-24cc5e12fee9' element={
                  <Navigate to="/admin" replace />
                } />

                <Route path='/admin' element={
                  <ProtectedRoute>
                    <BookingReport />
                  </ProtectedRoute>
                } />

                <Route path='/profile' element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                } />

                <Route path='/thankyou' element={<ThankYou />} />
                <Route path="/signin" element={<SignIn />} />
                <Route path="/register" element={<RegisterForm />} />
                <Route path='/forgotPassword' element={<ForgotPassword />} />
                <Route path='/changePassword' element={<ChangePassword />} />
                <Route index element={
                  <RequireAuth>
                    <Layout>
                      <Home />
                    </Layout>
                  </RequireAuth>
                } />
              </Routes>
            </BrowserRouter>
          </MsalProvider>
        ) :
          (
            <p>Initializing MSAL...</p>
          )}
    </div>

  );
}

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = useIsAuthenticated();
  const msalInstance = useMsalInstance();
  const login = async () => {
    await msalInstance.loginRedirect();
  };

  const { accounts } = useMsal();
  const userAccount = accounts[0];
  if (userAccount) {
    const email = userAccount.username;
    if (!email.toLowerCase().endsWith("@bernard.vn")) {
      alert("Vui lòng sử dụng email công ty để đăng nhập.");
      msalInstance.logoutRedirect();
    }
  }

  return isAuthenticated ? children :
    <div className='page-fullscreen' style={{ height: 100 + 'vh', margin: 0 }}>
      <Header />
      <div className='page-content blue-bg' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <div style={{ textAlign: 'center', padding: '80px', borderRadius: '10px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)' }}>
          <div style={{ paddingBottom: '20px' }}>
            Vui lòng đăng nhập bằng email công ty.
          </div>
          <input type="button" className='submit btn btn-primary' value="Sign In" onClick={login} />
        </div>
      </div>
      <Footer />
    </div >;
};

/*
function RequireAuth({ children }) {
  const storedValue = localStorage.getItem("user");
  var authenticated = false;
  if (storedValue) {
    authenticated = JSON.parse(storedValue)
  }
  return authenticated ? (children) : (<Navigate to="/signin" />);
}*/

function RequireAuth({ children }) {
  const storedValue = localStorage.getItem("user");
  const sessionTimeoutMinutes = 10; // customize your session timeout
  let authenticated = false;
console.log("Checking authentication status...");
console.log("Stored user data:", storedValue);
  if (storedValue) {
    try {
      const user = JSON.parse(storedValue);
      const loginTime = user.loginTime; // assume loginTime is a timestamp in ms
      const now = Date.now();
      const timeout = sessionTimeoutMinutes * 60 * 1000;

      console.log("Current time:", now);
      console.log("Login time:", loginTime);
      console.log("Session timeout (ms):", timeout);
      
      if (loginTime && now - loginTime < timeout) {
        authenticated = true;
      } else {
        // Session expired, clean up
        console.warn("Session expired, removing user data from localStorage.");
        localStorage.removeItem("user");
      }
    } catch (e) {
      console.error("Invalid user object in localStorage", e);
      localStorage.removeItem("user");
    }
  }

  return authenticated ? children : <Navigate to="/signin" />;
}

export default App;

export const CurrentLanguage = () => {
  return 'vi';
}

export const setCurrentLanguage = (lang) => {
  localStorage.setItem('language', lang);
}

export const getCurrentLanguage = () => {
  const storedValue = localStorage.getItem('language');
  return storedValue ? storedValue : 'vi';
}